import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

import StyledCardNoHeight from '../../../components/card/StyledCardNoHeight';
import { EditCredential, EditGuarantor, EditAvatar, RoleChange, ChangeConfessor } from '../../commonForUsers';
import EditMainData from './EditMainData';
import axiosInstance from '../../../api';
import SERVER_API_URL from '../../../config';

export default function UserUpdateForm({ userToBeUpdated, setUserToBeUpdated, updater }) {
  const [guarantor, setGuarantor] = useState();

  const handleRefreshUserData = async () => {
    try {
      const response = await axiosInstance.post(`${SERVER_API_URL}/user/findOneById/${userToBeUpdated.id}`);
      if (response.status === 200) {
        setUserToBeUpdated(response.data);
      }
    } catch (error) {
      // console.log(error)
    }
  };

  useEffect(() => {
    const getUserGuarantor = async () => {
      try {
        const response = await axiosInstance.post(
          `${SERVER_API_URL}/user/findOneGuarantorByUserId/${userToBeUpdated.id}`
        );
        if (response.status === 200) {
          setGuarantor(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getUserGuarantor();
  }, [userToBeUpdated, setGuarantor]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={5}>
          <StyledCardNoHeight sx={{ padding: 2, mb: 2 }}>
            <EditAvatar userToBeUpdated={userToBeUpdated} updaterId={updater && updater.id} updater={updater} />
          </StyledCardNoHeight>
          <StyledCardNoHeight sx={{ padding: 2 }}>
            <EditCredential
              userToBeUpdated={userToBeUpdated}
              handleRefreshUserData={handleRefreshUserData}
              updaterId={updater && updater.id}
            />
          </StyledCardNoHeight>
        </Grid>
        <Grid item xs={12} sm={7}>
          <StyledCardNoHeight sx={{ padding: { xs: 1, sm: 4 } }}>
            <EditMainData
              userToBeUpdated={userToBeUpdated}
              handleRefreshUserData={handleRefreshUserData}
              updater={updater && updater}
            />
          </StyledCardNoHeight>
        </Grid>
        <Grid item xs={12} sm={12}>
          <StyledCardNoHeight sx={{ padding: { xs: 1, sm: 5 } }}>
            {guarantor && (
              <EditGuarantor
                userId={userToBeUpdated.id}
                guarantorToBeUpdated={guarantor}
                handleRefreshUserData={handleRefreshUserData}
                updaterId={updater && updater.id}
              />
            )}
            {!guarantor && (
              <EditGuarantor
                userId={userToBeUpdated.id}
                guarantorToBeUpdated={guarantor}
                handleRefreshUserData={handleRefreshUserData}
                updaterId={updater && updater.id}
              />
            )}
          </StyledCardNoHeight>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledCardNoHeight sx={{ padding: { xs: 1, sm: 5 } }}>
            <RoleChange
              userToBeUpdated={userToBeUpdated}
              handleRefreshUserData={handleRefreshUserData}
              updater={updater && updater}
            />
          </StyledCardNoHeight>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledCardNoHeight sx={{ padding: { xs: 1, sm: 5 } }}>
            <ChangeConfessor
              userToBeUpdated={userToBeUpdated}
              setUserToBeUpdated={setUserToBeUpdated}
              handleRefreshUserData={handleRefreshUserData}
              updater={updater && updater}
            />
          </StyledCardNoHeight>
        </Grid>
      </Grid>
    </>
  );
}

UserUpdateForm.propTypes = {
  userToBeUpdated: PropTypes.object,
  setUserToBeUpdated: PropTypes.func,
  updater: PropTypes.object,
};
